import React from "react";
import { Wrapper, ContentWrapper } from "./style";
import Header from "../common/Header";
import Navigation from "../Navigation";
import { Text } from "../styledConstants";

export default function AuthLayout({ children, unauthorized = false }) {
  return (
    <React.Fragment>
      <Wrapper className="flex">
        <aside className="sidebar">
          <Navigation />
        </aside>
        <main className="main-content">
          <Header />
          <ContentWrapper>
            {unauthorized ? (
              <div
                style={{
                  padding: "2rem",
                  textAlign: "center",
                  color: "#721c24",
                  backgroundColor: "#f8d7da",
                  border: "1px solid #f5c6cb",
                  borderRadius: "8px",
                  margin: "2rem auto",
                  maxWidth: "500px",
                  fontWeight: "bold",
                  fontSize: "1.2rem",
                }}
              >
                🚫 You are not authorized to access this page!
              </div>
            ) : (
              children
            )}
          </ContentWrapper>
          <Text as="footer" className="copyrights" size="xsm" fw="light" color="color15">
            Copyrights © 2023. Mufin Pay. All rights reserved.{" "}
            <a
              style={{ color: "#333" }}
              target="_blank"
              rel="noreferrer"
              href="https://mufinpay.com/terms-and-conditions/"
            >
              Terms of use
            </a>{" "}
            |{" "}
            <a style={{ color: "#333" }} target="_blank" rel="noreferrer" href="https://mufinpay.com/privacy-policy/">
              Privacy policy
            </a>
          </Text>
        </main>
      </Wrapper>
    </React.Fragment>
  );
}
